// SocketIOComponent.js

import { useEffect } from "react";
import socketIOClient from "socket.io-client";

const SocketIOComponent = ({ endpoint, event, onEvent, clientId }) => {
  // const [socket, setSocket] = useState(null);

  useEffect(() => {
    const socket = socketIOClient(endpoint);
    // setSocket(socket);
    socket.on("connect", () => {
      if (clientId) {
        socket.emit("client_register", clientId);
        // console.log("Client registered:", clientId);
      }
    });

    // Subscribe to the event
    socket.on(event, (data) => {
      onEvent(data);
    });

    return () => {
      // Unsubscribe and disconnect the socket when the component unmounts
      socket.off(event);
      socket.disconnect();
    };
  }, [endpoint, event, onEvent]);

  return null; // This component doesn't render anything; it handles socket events.
};

export default SocketIOComponent;
